import React from "react";
import { Button, Tooltip } from "antd";
import { MessageCircle, X } from "lucide-react";
import { PinnedMessage } from "../../types/chat";
import styles from "./PinnedMessages.module.scss";

interface PinnedMessagePreviewProps {
  message: PinnedMessage;
  totalCount: number;
  onExpand: () => void;
  onUnpin: (messageId: string) => void;
  onScrollTo: (messageId: string) => void;
}

export const PinnedMessagePreview: React.FC<PinnedMessagePreviewProps> = ({
  message,
  totalCount,
  onExpand,
  onUnpin,
  onScrollTo,
}) => {
  const handleClick = () => {
    onScrollTo(message.MessageId);
  };

  const handleExpandClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onExpand();
  };

  const handleUnpinClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onUnpin(message.MessageId);
  };

  const renderMessageContent = () => {
    switch (message.Type) {
      case "Image":
        return (
          <div className={styles.message}>
            {message.ThumbUrl && <img src={message.ThumbUrl} alt="" className={styles.imagePreview} />}
            <span>[Hình ảnh]</span>
          </div>
        );
      case "Video":
        return (
          <div className={styles.message}>
            {message.ThumbUrl && <img src={message.ThumbUrl} alt="" className={styles.imagePreview} />}
            <span>[Video]</span>
          </div>
        );
      case "File":
        return <div className={styles.message}>[File] - {message.Message}</div>;
      default:
        return <div className={styles.message}>{message.Message}</div>;
    }
  };

  return (
    <div className={styles.preview} onClick={handleClick}>
      <MessageCircle className={styles.icon} size={20} />
      <div className={styles.content}>
        <div className={styles.creator}>{message.Creator}</div>
        {renderMessageContent()}
      </div>
      {totalCount > 1 ? (
        <Button onClick={handleExpandClick} size="small" className={styles.expandButton}>
          +{totalCount} ghim
        </Button>
      ) : (
        <Tooltip title="Bỏ ghim">
          <X className={styles.unpinButton} size={18} onClick={handleUnpinClick} />
        </Tooltip>
      )}
    </div>
  );
};
